export const DeleteButton = () => {
  return <button className="access-character-button">Delete</button>;
}